"use client";

import { c as _c } from "react/compiler-runtime";
import { QueryClientProvider } from "@tanstack/react-query";
import type { PropsWithChildren } from "react";
import { getQueryClient } from "@/lib/query/get-query-client";
export const QueryProvider = t0 => {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getQueryClient();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const queryClient = t1;
  let t2;
  if ($[1] !== children) {
    t2 = <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};